import React, {Component} from 'react';
import './style.css';
import {Translate} from "react-localize-redux";
import {withLocalize} from 'react-localize-redux';
import Header from '../../Header';

class MaintainPage extends Component {
	render() {
		return (
			<div className="container-pages-maintain flex-grow-1">
				<Header/>
				<div className="maintain-info"><Translate id="contents.maintain_in_progress"/></div>
			</div>
		)
	}
}

export default withLocalize(MaintainPage);


// WEBPACK FOOTER //
// ./src/04-containers/_pages/Maintain/index.js